export default __webpack_public_path__ + "static/media/mobileSideImages.afb7b299.svg";